export default __webpack_public_path__ + "static/media/mid-k-2-thumb.85db1c01.jpg";